import update from 'immutability-helper'
import _ from 'lodash'
import { 
    INVENTORY_LIST_FETCHED,
    INVENTORY_MODEL_LOADED,
    INVENTORY_MODEL_UPDATED_BY_FORM,
    INVENTORY_MODEL_UPDATED_ON_SERVER,
    SET_NEW_INVENTORY_ADJUSTMENT_MODEL,
    INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM
} from '../actions/types'

export default function user(state = {
    list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    model: {
        
    },
    pristine: {
        
    },
    dirty: false,
    adjustment: {
        
    }
}, action = {}) {
    switch(action.type) {
        case INVENTORY_LIST_FETCHED:
            return update(state, {
                list: {$set:action.payload}
            });

        case INVENTORY_MODEL_LOADED:
            return update(state, {
                model: {$set: action.payload},
                pristine: {$set: action.payload},
                dirty: {$set: false}
            });


        case INVENTORY_MODEL_UPDATED_BY_FORM:
            const {field, value} = action.payload;
            const updatedModel = update(state.model, {
                [field]: {$set: value}
            });
            if (_.isEqual(updatedModel, state.pristine)) {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: false}
                });
            } else {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: true}
                });
            }

        case INVENTORY_MODEL_UPDATED_ON_SERVER:
            return update(state, {
                pristine: {$set: action.payload},
                dirty: {$set: false}
            });

        case SET_NEW_INVENTORY_ADJUSTMENT_MODEL:
            return update(state, {
                adjustment: {$set: action.payload}
            });

        case INVENTORY_ADJUSTMENT_MODEL_UPDATED_BY_FORM:
            return update(state, {
                adjustment: {
                    [action.payload.field]: {$set: action.payload.value}
                }
            });

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/inventory.js